import { useState } from 'react';

import { Checkbox } from '@client/toolkit';

export function DebugFormComponents() {

  const [checked, setChecked] = useState(false);

  return (
    <article className="space-y-12">
      <Checkbox checked={checked} onChange={() => setChecked(() => !checked)} />
    </article>
  )

}
